import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable, Subscription } from 'rxjs';
import { SocialLinks } from 'src/@omnial/_models/settings.model';
import { RepositoryStaticService } from 'src/@omnial/_services/repository-static.service';
import { RepositoryService } from 'src/@omnial/_services/repository.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class SonicEnergyService {
  private subscriptions: Subscription[] = [];
  private useCache = environment.useCache;
  constructor(public spinner: NgxSpinnerService,
    public staticService: RepositoryStaticService,
    public repoService: RepositoryService,
    public snackBar: MatSnackBar,
    private route: ActivatedRoute) {
    this.route.fragment.subscribe((fragment: string) => {
      if (fragment && fragment === 'CacheBust') {
        this.useCache = false;
      }
    });
  }

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach((sub) => { sub.unsubscribe(); });
    }
  }

  public getSocials(): Observable<SocialLinks> {
    return new Observable((observer) => {
      if (environment.useCache) {
        this.subscriptions.push(this.staticService.get("Generic/Key/socials").subscribe({
          next: (staticRes) => {
            const socials = staticRes as SocialLinks;
            if (socials) {
              observer.next(socials);
              observer.complete();
            } else {
              this.subscriptions.push(this.repoService.getData('ElfaSettings/Socials').subscribe({
                next: (apiRes) => {
                  observer.next(apiRes as SocialLinks);
                  observer.complete();
                }
              }));
            }
          },
          error: () => {
            this.subscriptions.push(this.repoService.getData('ElfaSettings/Socials').subscribe({
              next: (apiRes) => {
                observer.next(apiRes as SocialLinks);
                observer.complete();
              }
            }));
          }
        }));
      } else {
        this.subscriptions.push(this.repoService.getData('ElfaSettings/Socials').subscribe({
          next: (apiRes) => {
            observer.next(apiRes as SocialLinks);
            observer.complete();
          }
        }));
      }
    });
  }
}
